import React, { Component } from "react"
import TableDiarioOcorrencias from "./TableDiarioOcorrencias"
import Layout from "../../Layout"
import { Loading, HttpError } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
export default class DiarioOcorrencias extends Component {
  constructor() {
    super()
    this.getDiarios = this.getDiarios.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { atas: [], initialAtas: [], showTable: false }
  }
  componentWillMount() {
    this.getDiarios()
  }
  getDiarios() {
    ApiHelper.getDiarioOcorrencias((diarios, error) => {
      if (diarios) {
        this.setState({
          diarios: diarios,
          initialDiarios: diarios,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialDiarios.filter(diarioDeOcorrencia => {
      return (
        Moment(diarioDeOcorrencia.created_at)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        Moment(diarioDeOcorrencia.dt_exec_contratual)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        Moment(diarioDeOcorrencia.dt_providencias)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        Moment(diarioDeOcorrencia.dt_resultados)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        diarioDeOcorrencia.resultados.toLowerCase().search(searchText) !== -1 ||
        diarioDeOcorrencia.providencias.toLowerCase().search(searchText) !==
          -1 ||
        diarioDeOcorrencia.exec_contratual.toLowerCase().search(searchText) !==
          -1 ||
        diarioDeOcorrencia.contrato.num_contrato
          .toLowerCase()
          .search(searchText) !== -1
      )
    })
    this.setState({
      diarios: filtered
    })
  }
  didDelete() {
    this.getDiarios()
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscalização">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Fiscalização">
        {this.state.showTable ? (
          <TableDiarioOcorrencias
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title={"Diários de ocorrências"}
            subtitle={"Listagem dos diários de ocorrências criados"}
            backgroundColor="as-blue"
            rows={this.state.diarios}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/diario-ocorrencias/DiarioOcorrencias.js